const TYPE_PEN = 'PEN';
const TYPE_HIGHLIGHTER = 'HIGHLIGHTER';
const TYPE_TEXT = 'TEXT';
const PEN_SIZES = [0.008, 0.015, 0.024];
const HIGHLIGHTER_SIZES = [0.018, 0.028, 0.044];
const TEXT_SIZES = [0.016, 0.032, 0.047];
export const AnnotationSchemaV3 = {
    VERSION: 3,
    TYPE_PEN: 'PEN',
    TYPE_HIGHLIGHTER: 'HIGHLIGHTER',
    TYPE_TEXT: 'TEXT',
    TYPE_TEXT_TMP: 'TEXT_TMP',
    // list of available colors,
    COLORS: ['f44336', 'E91E63', 'FF9800', 'FFEB3B', '4CAF50', '03A9F4', '9C27B0', 'FFFFFF', '000000'],
    TEXT_FONT_FAMILY: 'helvetica, sans-serif',
    TEXT_LINE_HEIGHT: 1.2,
    TYPES: [TYPE_PEN, TYPE_HIGHLIGHTER, TYPE_TEXT],
    TYPE_SIZES: {
        [TYPE_PEN]: PEN_SIZES,
        [TYPE_HIGHLIGHTER]: HIGHLIGHTER_SIZES,
        [TYPE_TEXT]: TEXT_SIZES,
    },
    TYPE_COLOR_ALPHA: {
        [TYPE_PEN]: 1,
        [TYPE_HIGHLIGHTER]: 0.5,
        [TYPE_TEXT]: 1,
    },
};
//# sourceMappingURL=AnnotationSchemaV3.js.map